import { render, staticRenderFns } from "./FIleIcon.vue?vue&type=template&id=022401ec&"
import script from "./FIleIcon.vue?vue&type=script&lang=js&"
export * from "./FIleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports